import Cookies from 'js-cookie'
import moment from 'moment'

const TokenKey = 'token'
const grayKey = 'gray'
const TokenTime = 'tokenTime'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, expires) {
  const date = moment().add(expires, 'd').format('X')
  setTokenTime(date, expires)
  return Cookies.set(TokenKey, token, { expires: expires })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 灰度标识

export function getEquipment() {
  return Cookies.get('mobile');
}

export function setEquipment() {
  return Cookies.set('mobile',true);
}

export function removeGray() {
  return Cookies.remove(grayKey)
}

export function removeTokenTime() {
  return Cookies.remove(TokenTime)
}

export function getTokenTime() {
  return Cookies.get(TokenTime)
}
export function setTokenTime(time, expires) {
  return Cookies.set(TokenTime, time, { expires: expires })
}
// export function setTokenTime() {
//
// }
// export function serUserInfo(data, expires = 1) {
//   return Cookies.set('info', encodeURIComponent(JSON.stringify(data)), { expires: expires })
// }
//
// export function getUserInfo() {
//   return JSON.parse(decodeURIComponent(Cookies.get('info')))
// }
